import Chain33Rpc from '@33cn/chain33-rpc-api'

export default new Chain33Rpc('/yccApi', null, (e: Error) => {
  throw e
})